import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row } from "react-bootstrap";
import useAuth from "../../hooks/useAuth";



const ListKhandsInArthikSakha = () => {

  const handleRedirect = () => {
    navigate("/createkhand");
  }


  const [khands, setKhands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const khandsPerPage = 15;
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [pranthNames, setPranthNames] = useState({});
  const { auth } = useAuth();
  // const [selectedArthikSakhaId, setSelectedArthikSakhaId] = useState();
  const [selectedArthikSakhaId, setSelectedArthikSakhaId] = useState(auth?.level_id); // default value

  useEffect(() => {
    if (auth?.level_id) {
      setSelectedArthikSakhaId(auth.level_id);

    }
  }, [auth]);



  const fetchKhands = useCallback(async () => {
    setError(null); // clear previous error
    try {
      const response = await axiosPrivate.get(`list-khands-in-arthik-sakha?arthik_sakha_id=${selectedArthikSakhaId}`, {
        withCredentials: true,
      });
      const khandList = response.data;
      setKhands(khandList);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Vibhags:", error);
      setError(error?.response?.data?.message?.toString() || error?.message || "No Vibhags available.");
      setLoading(false);
    }
  }, [axiosPrivate, selectedArthikSakhaId]); // 👈 dependency added




  const handleViewClick = (khand_id, khand_name) => {
    // Navigate to the GetFranchise component with khandId as a URL parameter
    navigate(`/list/KhandSummary/${khand_id}/${khand_name}`);
  };
  const handleEditClick = (khandId) => {
    navigate(`/UpdateFranchise/${khandId}`);
  };


  useEffect(() => {
    fetchKhands();
  }, [selectedArthikSakhaId]);


  const indexOfLastKhand = currentPage * khandsPerPage;
  const indexOfFirstKhand = indexOfLastKhand - khandsPerPage;
  const currentKhand = khands.slice(indexOfFirstKhand, indexOfLastKhand);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(khands.length / khandsPerPage);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  // if (error) {
  //   return <div className="error">{error}</div>;
  // }

  return (
    <>

      {/* <Container> */}
      <section className="empbody">
        <div className="wrapperemp2">

          <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>

          {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Vibhag</button> */}
          <h3>Khands In<span className="colorChange"> {auth.level_name}</span> Arthiksakha</h3>

          <div className="table-container">
            <table id="customers">
              <thead>
                <tr>
                  <th>khand Id</th>
                  <th>khand Name</th>
                  <th>Khand Name (MALAYALAM)</th>
                  <th>Jilla Name</th>
                  <th>Options</th>
                </tr>
              </thead>

              <tbody>
                {error ? (
                  <tr>
                    <td colSpan="6" className="text-danger text-center">
                      {error}
                    </td>
                  </tr>
                ) : khands.length === 0 ? (
                  <tr>
                    <td colSpan="6">No Data available.</td>
                  </tr>
                ) : (
                  currentKhand.map(khand => (
                    <tr key={khand.khand_id}>
                      <td>{khand.khand_id}</td>
                      <td>{khand.search_tag}</td>
                      <td>{khand.khand_name}</td>
                      <td>{khand.jilla_name}</td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <button type="button" className="btn btn-info btn-ico newbtnstyles" onClick={() => handleViewClick(khand.khand_id, khand.khand_name,)}>
                            View
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>


            </table>
          </div>
          <div className="table-container">
            {totalPages > 1 && (
              <div className="pagination">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    disabled={currentPage === index + 1}
                  >
                    {index + 1}
                  </button>
                ))}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
              </div>
            )}
          </div>
        </div>
      </section>
      <TopBar />
      {/* </Container> */}
    </>
  );
};

export default ListKhandsInArthikSakha;
